import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion'

import { Typography, Grid, StepLabel, StepContent } from '@mui/material'
import { ModelAutocompleteField, ModelMenuSelectorField, OptionSelectorField, MenuSelectorField } from '@front/squirtle'

import UserUtils from '@front/volcanion/utils/user'

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <OptionSelectorField
        name='audience'
        options={[
          { label: I18n.t('driver.label.all'), value: 'all' },
          { label: I18n.t('driver.label', { count: 1 }), value: 'custom_drivers' }
        ]}
      />
    </Grid>
  </Grid>

const Row2 = ({ audience }) => {
  const autocompleteMutatorDriver = useCallback(q => ({
    or: [
      { info: { user_client_id: { startsWith: q } } },
      { info: { first_name: { startsWith: q } } },
      { info: { last_name: { startsWith: q } } }
    ]
  }), [])
  return (
    <Grid container spacing={1} size={12}>
      <Grid hidden={audience !== 'all'} size="grow">
        <ModelMenuSelectorField
          name='vehicle_options'
          label={I18n.t('options.vehicleoption.label', { count: -1 })}
          model_name='vehicleoption'
          labelKeys={['name_translated']}
          searchMode='search'
          loadOnMount
          multiple
        />
      </Grid>
      <Grid hidden={audience !== 'all'} size="grow">
        <ModelMenuSelectorField
          name='driver_options'
          label={I18n.t('options.useroption.label', { count: -1 })}
          model_name='useroption'
          labelKeys={['name_translated']}
          searchMode='search'
          loadOnMount
          multiple
        />
      </Grid>
      <Grid hidden={audience !== 'all'} size="grow">
        <MenuSelectorField
          label={I18n.t('vehicle.pairing_type')}
          name='is_paired'
          noneLabel={I18n.t('all')}
          options={[
            { label: I18n.t('broadcast.paired'), value: 'paired' },
            { label: I18n.t('broadcast.not_paired'), value: 'not_paired' },
          ]}
        />
      </Grid>
      <Grid hidden={audience === 'all'} size="grow">
        <ModelAutocompleteField
          name={'driver'}
          label={I18n.t('driver.search_multiple')}
          model_name={'user'}
          searchMode='search'
          searchQuery={'='}
          autocompleteMutator={autocompleteMutatorDriver}
          labelKeys={['label']}
          multiple
          loadOnFocus
          config={{
            forced_filter: { driverinfo: { '!': null } },
            populate: ['info', 'customerinfo'],
            mutator: user => ({
              label: UserUtils.getFormatedName({ ...user?.info, designation: user?.customerinfo?.name }, { prefix: user?.info?.user_client_id }),
              ...user
            })
          }}
          selectSingleOption
        />
      </Grid>
    </Grid>
  );
}


const Row3 = ({ audience }) =>
  <Grid container spacing={1} size={12}>
    <Grid hidden={audience !== 'all'} size="grow">
      <ModelAutocompleteField
        name={'cities'}
        label={I18n.t('city.label', { count: 2 })}
        searchQuery={'contains'}
        autocompleteKey={'name'}
        model_name={'city'}
        searchMode={'search'}
        labelKeys={['name_translated']}
        config={{
          initial_filter: {},
          sortBy: ['name_translated'],
          sortDirection: ['asc']
        }}
        multiple
      />
    </Grid>
    <Grid hidden={audience !== 'all'} size="grow">
      <ModelMenuSelectorField
        name={'billing_category'}
        label={I18n.t('contract.category')}
        noneLabel={I18n.t('all')}
        model_name={'billingcategory'}
        searchMode={'search'}
        labelKeys={['name_translated']}
        config={{ initial_filter: {} }}
        multiple
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='vehicletypes'
        label={I18n.t('vehicletype.label', { count: -1 })}
        model_name='vehicletype'
        labelKeys={['name_translated']}
        searchMode='search'
        loadOnMount
        multiple
        noneFirst
        noneLabel={I18n.t('all')}
      />
    </Grid>
  </Grid>


const PrimarySection = props => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('message.recipients')}</Typography>
  </StepLabel>
  <StepContent >
    <Grid container rowSpacing={2}>
      <Row1 {...props} />
      <Row2 {...props} />
      <Row3 {...props} />
    </Grid>
  </StepContent>
</>

export default React.memo(PrimarySection)
